import { useEffect } from 'react';

export function PageHead({ title }: { title: string }) {
  useEffect(() => {
    document.title = `${title} · AOTV Call`;
  }, [title]);
  return null;
}
